import { render, staticRenderFns } from "./mod2.vue?vue&type=template&id=99b92c52&scoped=true&"
import script from "./mod2.vue?vue&type=script&lang=js&"
export * from "./mod2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b92c52",
  null
  
)

export default component.exports